import { Button, Modal } from 'react-bootstrap'
import { TextEditor } from '../TextEditor'
import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '../../context/ThemeContext'
import { updatePageById } from '../../services/pages'
import useGetPages from '../../hooks/useGetPages'
import { useParams } from 'react-router-dom'
import { useBoardPersons } from '../../hooks'
import useSendAlert from '../../hooks/useSendAlert'
import Skeleton from 'react-loading-skeleton'
import { cleanMentions } from '../../utils/cleanMentions'
import { editPageInLoggedInUser, setSelectedPage, updateHomePages } from '../../store/slice/page-slice'
import { useDispatch } from 'react-redux'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const AddPageNote = ({
    setEditor,
    editor,
    setNoteModalShow,
    noteModalShow,
    page, boardName,
    setPages,
    pages,
    activeTab
}: any): React.JSX.Element => {
    const { theme } = useTheme()
    const params: any = useParams()
    const [disableBtn, setDisableBtn] = useState<boolean>(false)
    const [mentions, setMentions] = useState<any[]>([])
    const dispatch = useDispatch()

    const { getPageHandler, page: getPage } = useGetPages(params.boardId)

    const editRef: any = useRef()

    const { boardPersonsForSendAlert, optionsForSendAlertQuickNote, getBoardPersonHandler, isUserAssignLoading } = useBoardPersons(page)

    const {
        sendAlertToMentionPerson
    } = useSendAlert(
        boardPersonsForSendAlert,
        page,
        params?.boardId,
        undefined,
        null
    )

    const saveNotesHandler = async () => {
        if (editor) {
            setDisableBtn(true)
            const formData = new FormData();
            const editorDescriptionState: any = getPage?.description ? getPage?.description + `<br/>` + editor : editor
            formData.append('description', cleanMentions(editorDescriptionState));
            formData.append('title', getPage?.title);
            formData.append('boardName', boardName);
            page?.pageNumber && formData.append('pageNumber', page?.pageNumber);
            try {
                const res: any = await updatePageById(page?.id, formData)
                const updatedPage = res.data.data.page
                if (pages) {
                    const filteredPages = pages && pages?.filter((p: any) => p.id !== getPage.id)
                    setPages([updatedPage, ...filteredPages])
                } else {
                    dispatch(editPageInLoggedInUser(updatedPage))
                    dispatch(updateHomePages({ id: activeTab, updatedPage: updatedPage }))
                    if(page?.id === updatedPage.id) {
                        dispatch(setSelectedPage(updatedPage))
                    }
                }
                if (mentions.length > 0 && editorDescriptionState !== null)
                    sendAlertToMentionPerson(res.data.data.page, mentions, 'page-description')
            } catch (error) {
                // console.log(error)
            } finally {
                setNoteModalShow(false)
                setDisableBtn(false)
                setEditor(null)
            }

        }
    }
    useEffect(() => {
        getPageHandler(page?.id)
        getBoardPersonHandler(params?.boardId || page?.boardId, page)
        //eslint-disable-next-line

    }, [page?.id])

    useEffect(() => {

        let imageSrc: any
        const editImg: any = document.querySelectorAll(`div.ql-editor[contenteditable="false"] img`)

        for (let i = 0; i < editImg.length; i++) {
            editImg[i].classList.add('cursor-pointer')
            editImg[i].classList.add('d-block')
            editImg[i].style.maxWidth = '30%'
            //eslint-disable-next-line
            editImg[i].addEventListener('click', () => {
                //eslint-disable-next-line
                imageSrc = editImg[i].getAttribute('src')
                editRef.current?.handleModal(imageSrc)
            })
        }
    }, [page?.description])
    useEffect(() => {
        if (noteModalShow && editRef.current) {
            editRef.current.focus(); // Focus the editor when the modal is shown
        }
    }, [noteModalShow]);

    const handleFocus = () => {
        if (setEditor) {
            setEditor((prevEditor: any) => {
                return prevEditor;
            });
        }
    };

    return (
        <Modal
            contentClassName={theme === 'dark' ? 'theme__div' : ''}
            show={noteModalShow}
            onHide={() => setNoteModalShow(false)}
            size='lg'
            onEntered={handleFocus}
        >
            <Modal.Header>
                <Modal.Title
                    className={`text-center w-100 fw-bold ${theme === 'dark' ? 'white__text' : ''}`}
                >
                    Notes for {page?.title}
                </Modal.Title>
                <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`} onClick={() => {
                    setNoteModalShow(false)
                }}></i>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '500px', overflowY: 'scroll' }} className={theme === 'dark' ? 'dark-mode-placeholder' : ''}>

                {isUserAssignLoading ? <React.Fragment>
                    <Skeleton count={1} height={35} />
                    <Skeleton count={1} height={155} />
                </React.Fragment>
                    : (<TextEditor
                        placeholder={'Add note'}
                        setEditor={setEditor}
                        editor={editor}
                        boardId={params.boardId}
                        onFocus={handleFocus}
                        optionsForSendAlert={optionsForSendAlertQuickNote}
                        setMentions={setMentions}
                    />)}
            </Modal.Body>
            <Modal.Footer className='my-1'>
                <Button
                    variant='secondary'
                    onClick={() => {
                        setNoteModalShow(false)
                        setEditor(null)
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant='primary'
                    disabled={!editor || isUserAssignLoading || disableBtn}
                    onClick={() => {
                        saveNotesHandler()
                    }}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddPageNote
